import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when there is any trigger from within the Geofencing process.
 * @memberOf Playtech.API.events
 * @event geofencing-trigger
 * @type {callback}
 * @param {object} detials
 * @param {number} details.reason - reason for the trigger for geolocatoin.
 * @example Playtech.on('geofencing-trigger', ({ reason }) => { ... });
 */
export const GEOFENCING_TRIGGER = 'geofencing-trigger';

export const useOnGeofencingTrigger = (eventTarget: EventTarget): void => {
    const triggerGeofencingTriggerEvent = useCallback((detail: {
        trigger?: any;
        triggerCode?: number | string;
        response?: any;
        message?: string;
    }) => {
        const event = new CustomEvent(GEOFENCING_TRIGGER, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('geofencing-trigger', triggerGeofencingTriggerEvent);

        return () => {
            publicEventsAPIService.off('geofencing-trigger', triggerGeofencingTriggerEvent);
        };
    }, [triggerGeofencingTriggerEvent]);
};
